import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "userManagement",
  initialState: {
    userList: [],
    isUpdateEnabled: false,
    isUpdating: false,
    isAdding: false,
    isNewUserModelOpened: false,
    isUpdateUserModelOpened: false,
    updateUser: {},
    availableUserList: [],
    updateErrors: [],
    languagePreference: "en",
  },

  reducers: {
    // GET Request
    updateUserLanguagePreference: (userManagement, action) => {
      userManagement.languagePreference = action.payload;
    },
    userInfoReceiving: (userManagement, action) => {
      userManagement.userList = [];
    },
    userInfoReceived: (userManagement, action) => {
      userManagement.userList = action.payload ? action.payload : [];
    },
    userInfoRetrievalFailed: (userManagement, action) => {
      userManagement.userList = [];
      userManagement.updateErrors = action.payload ? action.payload : "Error";
    },
    allUsersReceiving: (userManagement, action) => {
      userManagement.availableUserList = [];
    },
    allUsersReceived: (userManagement, action) => {
      userManagement.availableUserList = action.payload ? action.payload : [];
    },
    allUsersRetrievalFailed: (userManagement, action) => {
      userManagement.availableUserList = [];
    },
    // POST Update User Request
    detailsUpdating: (userManagement, action) => {
      userManagement.isUpdating = true;
      userManagement.updateErrors = [];
    },
    detailsUpdated: (userManagement, action) => {
      userManagement.isUpdating = false;
      if (action.payload?.errorMessage) {
        console.log(
          "action.payload?.errorMessage",
          action.payload?.errorMessage
        );
        userManagement.updateErrors = action.payload?.errorMessage;
      } else {
        userManagement.updateErrors = [];
      }
    },
    detailsUpdateFailed: (userManagement, action) => {
      userManagement.isUpdating = false;
      userManagement.updateErrors = action.payload ? action.payload : "Error";
    },
    updateToggled: (userManagement, action) => {
      userManagement.isUpdateEnabled = action.payload.status;
    },

    NewUserModelToggled: (userManagement, action) => {
      userManagement.isNewUserModelOpened = action.payload.status;
    },

    userAdding: (userManagement, action) => {
      userManagement.isAdding = true;
    },
    userAdded: (userManagement, action) => {
      userManagement.isAdding = false;
    },
    userAddingError: (userManagement, action) => {
      userManagement.isAdding = false;
      userManagement.updateErrors = action.payload ? action.payload : "Error";
    },

    UpdateUserModelToggled: (userManagement, action) => {
      userManagement.isUpdateUserModelOpened = action.payload.status;
    },

    updateUserSelected: (userManagement, action) => {
      userManagement.updateUser = action.payload.user;
    },
  },
});

export const {
  userInfoReceiving,
  userInfoReceived,
  userInfoRetrievalFailed,
  detailsUpdating,
  detailsUpdated,
  detailsUpdateFailed,
  allUsersReceiving,
  allUsersReceived,
  allUsersRetrievalFailed,
  updateToggled,
  NewUserModelToggled,
  UpdateUserModelToggled,
  updateUserLanguagePreference,
  updateUserSelected,
  userAdding,
  userAdded,
  userAddingError,
} = slice.actions;

export default slice.reducer;

// action creator

export const getUserDetails = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers",
    method: "post",
    data: data,
    onStart: userInfoReceiving.type,
    onSuccess: userInfoReceived.type,
    onError: userInfoRetrievalFailed.type,
  });

export const getAllUsers = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers/allusers",
    method: "get",
    onStart: allUsersReceiving.type,
    onSuccess: allUsersReceived.type,
    onError: allUsersRetrievalFailed.type,
  });

export const updateLanguagePreference = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokers/updateLanguagePreference",
    method: "post",
    data: data,
    onStart: detailsUpdating.type,
    onSuccess: detailsUpdated.type,
    onError: detailsUpdateFailed.type,
  });

export const updateDetails = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokers/edit",
    method: "post",
    data: data,
    onStart: detailsUpdating.type,
    onSuccess: detailsUpdated.type,
    onError: detailsUpdateFailed.type,
  });

export const deleteUserImg = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokers/img",
    method: "delete",
    data: data,
    onStart: detailsUpdating.type,
    onSuccess: detailsUpdated.type,
    onError: detailsUpdateFailed.type,
  });

export const addNewUser = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/brokers/register",
    method: "post",
    data: data,
    onStart: userAdding.type,
    onSuccess: userAdded.type,
    onError: userAddingError.type,
  });

export const toggleUpdateButton = createAction(
  updateToggled.type,
  function toggle(toggleFlag) {
    return {
      payload: {
        status: toggleFlag,
      },
    };
  }
);

export const toggleNewUserModel = createAction(
  NewUserModelToggled.type,
  function toggle(toggleFlag) {
    return {
      payload: {
        status: toggleFlag,
      },
    };
  }
);

export const toggleUpdateUserModel = createAction(
  UpdateUserModelToggled.type,
  function toggle(toggleFlag) {
    return {
      payload: {
        status: toggleFlag,
      },
    };
  }
);

export const selectUpdateUser = createAction(
  updateUserSelected.type,
  function toggle(userObj) {
    return {
      payload: {
        user: userObj,
      },
    };
  }
);

// Selector

export const getUserInformation = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.userList
);

export const getAllUsersList = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.availableUserList
);

export const getUserLanguagePreference = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.languagePreference
);

export const getUpdateButtonStatus = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.isUpdateEnabled
);

export const geNewUserModelStatus = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.isNewUserModelOpened
);

export const getUpdateUserModelStatus = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.isUpdateUserModelOpened
);

export const getUpdateUserSelected = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.updateUser
);

export const getUpdateErrors = createSelector(
  (state) => state.entities.userManagement,
  (userManagement) => userManagement.updateErrors
);
